<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { createRealEstateBrokerCommissionPresenter } from '../composables/realEstateBrokerCommissionPresenter';

defineProps({
  detail: { type: Object, required: true },
  agreed: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

defineEmits(['update:agreed']);

const { t } = useI18n();
const { money, percentage } = createRealEstateBrokerCommissionPresenter(t);
</script>

<template>
  <LaisCard density="flush">
    <div class="space-y-5 p-5 sm:p-7">
      <div>
        <h2 class="font-redHatDisplay text-2xl font-semibold text-lais-text">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.REQUEST.TITLE') }}
        </h2>
        <p class="mt-2 text-sm text-lais-text-body">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.REQUEST.DESCRIPTION') }}
        </p>
      </div>
      <div class="rounded-lais bg-lais-bg-soft p-5">
        <span
          class="inline-flex rounded-full bg-lais-primary-50 px-2.5 py-1 text-xs font-semibold text-lais-primary"
        >
          {{ percentage(detail.porcentagem_propria) }}
        </span>
        <p class="mt-4 text-sm font-semibold text-lais-text-muted">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.HERO.OWN_VALUE') }}
        </p>
        <p class="mt-1 font-redHatDisplay text-4xl font-bold text-lais-text">
          {{ money(detail.valor_proprio) }}
        </p>
      </div>
      <label
        class="flex cursor-pointer items-start gap-3 rounded-lais border border-lais-border-soft p-4"
        :class="
          disabled
            ? 'cursor-not-allowed opacity-60'
            : 'hover:border-lais-primary'
        "
      >
        <input
          :checked="agreed"
          :disabled="disabled"
          class="mt-0.5 size-4 accent-lais-primary"
          type="checkbox"
          @change="$emit('update:agreed', $event.target.checked)"
        />
        <span class="text-sm font-medium text-lais-text">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.REQUEST.AGREE') }}
        </span>
      </label>
    </div>
  </LaisCard>
</template>
